import addRoute from '@/router/add-route';

const ShippingZones = () => import('@/modules/shipping-zones/shipping-zones.vue');
const ShippingZonesForm = () => import('@/modules/shipping-zones/shipping-zones-form.vue');

const shippingZones = [
    addRoute({
        name: 'shipping-zones',
        path: '/shipping-zones',
        component: ShippingZones,
        root: {label: 'Settings', name: 'settings'},
    }),

    addRoute({
        name: 'add-shipping-zone',
        path: '/shipping-zones/add',
        component: ShippingZonesForm,
        root: {label: 'Settings', name: 'settings'},
    }),

    addRoute({
        name: 'edit-shipping-zone',
        path: '/shipping-zones/update/:id',
        component: ShippingZonesForm,
        props: true,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default shippingZones;
